import { IRealTimeNotificationMessage } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationMessage";
import { RealTimeNotificationOperation } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationOperation";
import { realTimeNotificationClient } from "@/Common/Api/RealTimeNotification/SignalRClient";
import { BaseStore } from "@/Common/Stores/BaseStore";

type IRealTimeNotificationHandlerMethod = (message: IRealTimeNotificationMessage, store: BaseStore) => void;

/**
 * A handler which processes real-time notifications from the server.
 */
class RealTimeNotificationEventHandler {
    /** The context of the store where the real-time notification handler will be used */
    private context: BaseStore;

    /**
     * Create an instance.
     * @param context The store where the real-time notification handler is going to be used.
     */
    constructor(context: BaseStore) {
        this.context = context;
    }

    /**
    * Subscribe to the real-time notification channel for a message type.
    * @param messageType The operation that will invoke this function.
    * @param handlerMethod The function to invoke when a message is received.
    * @param autoEmit True by default. If set to false, the function will not emit changes to listeners automatically.
    */
    protected RegisterOperation(messageType: RealTimeNotificationOperation, handlerMethod: IRealTimeNotificationHandlerMethod, autoEmit?: boolean): void {
        realTimeNotificationClient.subscribe(
            messageType,
            message => this.invokeEventHandler(handlerMethod, message, autoEmit ?? true)
        );
    }

    private invokeEventHandler(handlerMethod: IRealTimeNotificationHandlerMethod, message: IRealTimeNotificationMessage, autoEmit: boolean): void {
        handlerMethod(message, this.context);
        if (autoEmit) {
            this.context.EmitChangeToListeners();
        }
    }
}

export { RealTimeNotificationEventHandler };
